import { Component, Input, OnInit } from '@angular/core';
import { CaseSubjectModel } from '@app/ps/models/case-subject.model';
import { CaseOwnershipGroupModel } from '@app/ps/models/case-ownership-group.model';

@Component({
  selector: 'case-owner',
  templateUrl: './case-owner.component.html',
  styleUrls: ['./case-owner.component.scss']
})
export class CaseOwnerComponent implements OnInit {

  @Input() caseOwnershipGroup: CaseOwnershipGroupModel;
  @Input() caseSubjectIndex = 0;
  @Input() onlySubject = false;
  @Input() canEdit;
  @Input() obligationType;
  @Input() obligationBonusPeriod;
  @Input() manualRentPriceSet: boolean;
  @Input() editFunction: Function;

  caseSubject: CaseSubjectModel;

  constructor() { }

  ngOnInit() {
    this.caseSubject = this.caseOwnershipGroup.caseSubjects[this.caseSubjectIndex];
  }
}
